import React from 'react';
import classes from './drawerHeader.module.css';
import { CloseIcon } from '../../../../../components'; //'../../../';

var DrawerHeader = function DrawerHeader(_ref) {
  var title = _ref.title,
      close = _ref.close;
  return React.createElement("div", {
    className: classes.drawerHeader
  }, React.createElement("h5", {
    className: "text-white text-h5 leading-156"
  }, title), React.createElement("div", {
    onClick: close,
    className: classes.closeWrapper,
    role: "button"
  }, React.createElement(CloseIcon, null)));
};

export default DrawerHeader;